import { Stack } from "@mui/material";
import { ProductType } from "@repo/api";
import { cs, FormErrorMessage } from "@repo/ui";
import { useFormikContext } from "formik";
import { type FC } from "react";
import { useContractTypeContext } from "../../context/ContractTypeContext";
import Form from "../Form/Form";
import DatePicker from "../Form/Input/DatePicker";
import Switch from "../Form/Input/Switch";
import TriggerButton from "../Link/TriggerButton";
import { SingleStepDrawer } from "./SingleStepDrawer";

type FilterProps = {
	handleHideDrawer: () => void;
}

const ResetFilter: FC<FilterProps> = ({ handleHideDrawer }) => {
	const { isSubmitting } = useFormikContext();

	return (
		<TriggerButton
			variant="text"
			type="reset"
			disabled={isSubmitting}
			onClick={handleHideDrawer}
		>
			Zrušit&nbsp;filtr
		</TriggerButton>
	);
}

const FilterTransactionsDrawer: FC<FilterProps> = ({ handleHideDrawer }) => {
	const { contractType } = useContractTypeContext();
	const { errors } = useFormikContext();
	return (
		<SingleStepDrawer>
			<Form
				spacing={6}
				actions={<ResetFilter handleHideDrawer={handleHideDrawer} />}
			>
				<Stack spacing={4}>
					<Switch name="employer" label="Příspěvky zaměstnavatele" />
					<Switch name="client" label="Příspěvky klienta" />
					<Switch name="state" label="Státní příspěvky" />
					{contractType === ProductType.Pf && (
						<Switch name="other" label="Ostatní" />
					)}
					{errors.isAnySelected && (
						<FormErrorMessage>{cs.formErrors.isAnySelected}</FormErrorMessage>
					)}
				</Stack>
				<DatePicker
					name="dateFrom"
					placeholder="Datum od"
					options={{ maxDate: new Date(), minDate: new Date(1990, 1, 1) }}
				/>
				<DatePicker
					name="dateTo"
					placeholder="Datum do"
					options={{ maxDate: new Date(), minDate: new Date(1990, 1, 1) }}
				/>
			</Form>
		</SingleStepDrawer>
	);
};

export default FilterTransactionsDrawer;
